// imports
import React from 'react';

// interfaces / types / consts
interface Props {
  heading: string;
  children: JSX.Element;
  headingClass?: string;
}

// exports
export default function Section(props: Props): JSX.Element {
  const {
    heading, children, headingClass
  } = props;
  return (
    <div className="section">
      <div className={`heading ${headingClass}`}>{heading}</div>
      {children}
    </div>
  );
}

Section.defaultProps = { headingClass: '' };
